import { IMarketCategoriesData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketCategory';
import { useEffect } from 'react';
import useCategoriesList from '@/creditflowresearch/application/hooks/apiHooks/useCategoriesList';

const useCategories = ({
  categories: categoriesList,
  payload,
  hasServerError,
}: IMarketCategoriesData) => {
  const { categories, getCategories } = useCategoriesList(categoriesList);

  useEffect(() => {
    if (hasServerError) {
      getCategories(payload);
    }
  }, [hasServerError]);

  return { categories };
};

export default useCategories;
